import { useDraggable } from '@dnd-kit/core';

import { cn } from '@/utils/cn';

import { type FieldConfig, FORM_FIELDS_CONFIG } from './fields.config';

interface DraggableFieldProps {
  id: string;
  data: FieldConfig;
  label: string;
  description?: string;
}

export function FieldLibrary() {
  return (
    <div className="p-4 h-full overflow-y-auto">
      <h3 className="mb-4 font-semibold text-lg">Field Library</h3>

      {Object.entries(FORM_FIELDS_CONFIG).map(([category, fields]) => (
        <div key={category} className="mb-4">
          <h4 className="font-medium text-[var(--muted-foreground)] mb-2">{category}</h4>
          <div className="grid grid-cols-1 gap-2">
            {fields.map((field) => (
              <DraggableField key={field.type} id={field.type} data={field} label={field.label} />
            ))}
          </div>
        </div>
      ))}
    </div>
  );
}

function DraggableField({ id, data, label, description }: DraggableFieldProps) {
  const { attributes, listeners, setNodeRef, isDragging } = useDraggable({
    id,
    data,
  });

  const Icon = data.icon;

  return (
    <div
      ref={setNodeRef}
      {...listeners}
      {...attributes}
      className={cn(
        'cursor-grab border rounded-md py-2 px-3 shadow-sm border-[var(--border)] bg-[var(--popover)] hover:bg-[var(--muted)]/60 hover:border-[var(--border)]/60 transition-colors',
        isDragging && 'bg-[var(--popover)] border-[var(--primary)]'
      )}
    >
      <div className="flex items-center gap-2">
        <Icon className="h-4 w-4 text-[var(--primary)] shrink-0" />
        <div>
          <div className="font-medium">{label}</div>
          {description && <p className="text-sm text-[var(--muted-foreground)]">{description}</p>}
        </div>
      </div>
    </div>
  );
}
